import type { FaireProductEntity } from "../../entity_types/product";

export const p_598gfwvh32: FaireProductEntity = {
  token: "p_598gfwvh32",
  type: "product",
  name: "City Glam Chain Necklace",
  brandToken: "b_eow5j1bbc8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/d8c78b72668b352c9e54bf352cf66da211530e04f38aafe9b09e694acd03f094.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f586bbadae872fa390401da0ee95e09b31dbe19eee297c8da49f95010a1d9496.jpeg",
    "https://cdn.faire.com/fastly/130ced2ce0b98a917b6c11affc8dc69b98f5ce4651d10a4b7d7fdda18c6945bf.jpeg",
    "https://cdn.faire.com/fastly/074dfdeacd08250751f51e26cccb05faefcc838487f0c5cb6ed4afe84cffcd4d.jpeg",
    "https://cdn.faire.com/fastly/2263e5ef89cbb96b9c411d92eeb9c61a52329b2b3552032c11dd2560a7282829.jpeg",
  ],
  priceDollars: 25.48,
  description:
    'Sparkling stones and a cuban chain come together for a modern and chic piece. A perfect addition to any outfit, this necklace exudes elegance and sophistication.\n\nDimensions: Approximately 16"\n\n18k gold plated brass\n\nLead and nickel free\n\nMade in China',
  tags: [],
  msrpDollars: 50.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:29.597Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
